import guid from '@/lib/guid';

import {
  loadParameter,
  loadHydrator
} from '@/components/charts/';
import
{
pickItem,
resolve
} from "@/components/charts/common";

import {getChart} from '@/models/chart';

import {encode, decode} from '@/lib/common';


export default class Element {
  constructor({
    id = null,
    name = `Chart`,
    description = ``,
    input = {},
    schema = {},
    content = {},
    type = null,
    parameters = null,
    typeGroup = 'chart',
    projectId = null
  } = {}) {
    this.id = id;
    if (!this.id) {
      this.id = guid.createId('chart');
    }
    this.input = input;
    this.type = type;
    this.name = name;
    this.description = description;
    this.instance = null;
    this.typeGroup = typeGroup;
    this.projectId = projectId;
    this.schema = schema;
    this.content = content;
    this.parameters = parameters;
    this.hydrator = function() {};
    this.subHeaders = [];
    this.dataSource = {headers: []};
    this.reset();
    this.setParameters(true);
    this.loadDefaults();
    this.tree = {};
    this.render = false;
    this.dataSources = [];
    this.drawn = false;
    this.dataSource = null;
    this.dialog = false;
    this.subSeries = [];
    this.firstCall = false;
    this.lightUpdate = false;
    this.loading = false;
    this.overlayContent = "";
    this.overlayContentStyle = "";
    this.references = {};

    this.parentId = null;

    this.status = {
      loadding: false,
      loadingSubChart: false
    }

    // console.log("chartname", name);



  }
  setParentId(parentId) {
    this.parentId = parentId;
  }
  setLoading() {}
  getParentId() {
    return this.parentId;
  }
  ready(b) {
    this.render = b;
  }
  setType(type) {
    this.type = type;
    this.loadParametersAndHydrator();
  }
  setlightUpdate(aUpdate) {
    this.lightUpdate = setLightUpdate;
  }
  loadParameters() {
    this.parameters = loadParameter(this.type);
    this.loadParameterContents(); // load saved contents
    this.loadParameterItems(); // load related datasources
    // console.log(this.tree);
    //console.log(this.tree.dataSource);
    for (var key in this.parameters) {
      // console.log("key", key);
       if (this.parameters.hasOwnProperty(key)) {
         let parameter = this.parameters[key];
          // console.log("changed parameter " + key + " " + this.type, parameter);
         this.changed(parameter);
       }
    }
  }
  loadHydrator() {
    this.hydrator = loadHydrator(this.type);
  }
  loadParametersAndHydrator() {
    this.loadParameters();
    this.loadHydrator();
  }
  setTree(tree) {
    this.tree = tree;
    this.tree.parameters = this.parameters;
  }
  reset() {
    let options = {};
    options.chart = {};
    options.chart.id = this.id + this.type;
    options.dataLabels = {
      enabled: false
    };
    this.chartData = {
      valid: false,
      dialog: false,
      options: options,
      subSeries: [],
      series: [],
      expand: {show: false, display: false, style: {position: 'absolute', top: '5px', right: '50px', 'z-index': 5000 }}
    };
  }
  groupParametersByType(parameters) {

    if(this.type == 'form.builder') {
      this.parameterGroups = [
        {id: 'form.builder', name: 'Form Builder'},
        {id: 'default', name: 'Data'},
        {id: 'design', name: 'Design'},
        {id: 'link', name: 'Links'},
        {id: 'filter', name: 'Filters'},
        {id: 'sqlQuery', name: 'SQL'},
        {id: 'code', name: 'Code'},
        {id: 'layeredInfo', name: 'Layered Info'}
      ];
    } else {
      this.parameterGroups = [
        {id: 'default', name: 'Data'},
        {id: 'design', name: 'Design'},
        {id: 'link', name: 'Links'},
        {id: 'filter', name: 'Filters'},
        {id: 'sqlQuery', name: 'SQL'},
        {id: 'code', name: 'Code'},
        {id: 'layeredInfo', name: 'Layered Info'}
      ];
    }

    this.tab = null;
    this.tabs = {};
    



  }
  setTab(tab) {
    this.tab = tab;
    if(tab && tab.id != this.id) {
      
      this.tabs[tab.id] = tab;
    }
    
  }
  stringForId(str) {
    return str.replace(/[\W_]+/g," ").toLowerCase();
  }
  findChart(settings, item) {
    try {
      return this.tree.charts.find(item => item.name.toLowerCase() === settings.functionValue.toLowerCase());
    } catch(error) {
      if(typeof item != "undefined") {
        if(typeof item.attr_popup != "undefined") {
          const popup = item.attr_popup;
          return this.tree.charts.find(item => popup === item.id || this.stringForId(popup) === this.stringForId(item.name));
        }
      }
      const expandToPageId = resolve("expandToPage.value", this.parameters);
      return this.tree.charts.find(item => item.id === expandToPageId);;
    }
  }
  isCallableAction(item) {
    try {
      const call = item.attr_call_function;
      if(call) {
        return true;
      }
    } catch(error) {

    }
    return false;
  }
  async loadSubChartInDialog(settings, item, callback) {
   
    try {

      if(this.isCallableAction(item)) {
        callback();
        return;
      }

      // console.log("settings", settings);
      // console.log("item", item);
      let chart = this.findChart(settings, item);
      
      this.chartData.expandToPageChart  = null;
      if(chart) {
        
        

        if(chart.getLoadedStatus() == false) {

          chart = await getChart(chart.id);
          
        }

        console.log("loadSubChartInDialog chart.id", chart.id);
        // console.log("chart.type", chart.type);
        
        chart.setTree(this.tree);
        // chart.initialiseGrids(this.tree);
        // chart.initialiseGrids(state, item, settings);
        chart.setLoadedStatus(true);
        this.updateChart(chart);

        // console.log("chart.getLoadedStatus()", chart.getLoadedStatus());
        this.chartData.expandToPageChart = chart;
        this.hasDialog = true;


        callback();
        
        console.log("finished");
        // console.log("this.chartData.expandToPageChart", this.chartData.expandToPageChart);
      }

    } catch(error) {
      console.log("error", error)
    }
  }
  updateChart(chart) {
    try {
      for(let i = 0; i < this.tree.charts.length; i++) {
        if(this.tree.charts[i].id == chart.id) {
          // console.log("found match", chart.id);
          this.tree.charts[i] = chart;
        }
      }
    } catch(error) {
      console.log("error", error);
    }
  }
  getTab(key) {
    if(typeof key != "undefined" ) {
      return typeof this.tabs[key] != "undefined" ? this.tabs[key] : null;
    }
    return this.tab;
  }
  setParameters(useSaved = false) {
    this.parameters = loadParameter(this.type);
    this.groupParametersByType(this.parameters);
    this.hydrator = loadHydrator(this.type);
  }
  loadParameterContents() {
    if (typeof this.schema.parameters == "undefined") {
      this.schema.parameters = {};
    }

    let parameters = this.parameters;
    Object.entries(this.schema.parameters).forEach(entry => {
      let key = entry[0];
      let item = entry[1];
      if (typeof parameters[key] != "undefined") {
        parameters[key].value = item.value;
        if(typeof item.value2 != "undefined") {
          parameters[key].value2 = item.value2;
        }

      }
    });
    //console.log("loadDefaults");
    //console.log(this.schema.parameters);

    // # Steps and methods
    // 1. loadData
    // 2. changeType -> if type uses different hydrator ? reloadHydrator, if different parameter, reloadParameter
    // 3. hydrate (transforms for chart) using current data
    // 4. loadDataAndHydrate
    //
  }
  setSchemaParameters() {
    this.schema.parameters = {};
    let schemaParameters = this.schema.parameters;
    Object.entries(this.parameters).forEach(entry => {
      let key = entry[0];
      let item = entry[1];
      schemaParameters[key] = {};
      schemaParameters[key].value = typeof item.value != "undefined" ? item.value : '';
      schemaParameters[key].value2 = typeof item.value2 != "undefined" ? item.value2 : '';
    });
    // console.log("this.schema.parameters", this.schema.parameters);
  }
  hydrateOnce() {
    if(this.firstCall == false) {
      this.hydrate();
    }
  }
  hydrate(from) {
    try {
      if(typeof from != "undefined") {
        // console.log("called from ", from);
      }
      this.firstCall = true;
    //  console.log("hydrate called");
      // Style
      this.chartData.elevation = resolve("boxShadow.value", this.parameters);
      let expandToPageId = resolve("expandToPage.value", this.parameters);
      let chart = this.tree.charts.find(item => item.id === expandToPageId);
      this.chartData.expandToPageChart  = null;
      if(chart) {
        this.chartData.expandToPageChart = chart;
        this.hasDialog = true;
        // console.log("this.chartData.expandToPageChart", this.chartData.expandToPageChart);
      }

      this.hydrator(this.parameters, this.chartData, this);
    } catch(err) {

    }
  }
  loadQuery() {
    // loads sql query
  }
  changed(parameter) {

    const sources = this.tree;
    if (typeof parameter.items == "undefined") {
      parameter.items = [];
    }
    // let item = parameter.items.length == 1 ? parameter.items[0] : parameter.items.find(item => item.id === parameter.value);
    if(parameter.type != "multi-select") {
    let item = parameter.items.find(item => item.id === parameter.value);
    try {
      if(!item) {
        item = parameter.items.find(item => item.name === parameter.value2);
      }
    } catch(error) {

    }

    
    if(!item && parameter.items.length) {
      item = parameter.items[0];
      // item = parameter.items[0];
      if(typeof item.id != "undefined") {
        parameter.value = item.id;
      }
    }
    if (item) {
      parameter.item = item;
      if(typeof item.name != "undefined") {
        parameter.value2 = item.name;
        // console.log("changed.", item);
      }
      this.loadParameterItems(sources);
    }
  }
    this.setSchemaParameters(); // update parameter contents to save
    // this.loadSchemaParameters();
  }
  loadSchemaParameters() {
    // @togo
  }
  loadDefaults() {

  }
  setReference(key, value) {
    this.references[key] = value;
  }
  getReference(key) {
    if(typeof this.references[key] != "undefined") {
      return this.references[key];
    }
    return null;
  }
  loadDefaultDataSources() {
    // console.log("this.tree", this.tree);
    // @togo
    // const sources = this.tree;
    // const changed = this.changed;
    // for (var key in this.parameters) {
    //   if (this.parameters.hasOwnProperty(key)) {
    //     let parameter = this.parameters[key];
    //     this.changed(parameter, sources);
    //   }
    // }
  }
  filteredCharts(c, id) {
    let charts = [{id: null, name: 'None'}];
    if(c) {
      for(var i = 0; i < c.length; i++) {
        if(c[i].id != id) {
          charts.push(c[i]);
        }
      }
    }
    return charts;
  }
  loadParameterItems() {
    let sources = this.tree;

    sources.parameters = this.parameters;
    sources.filteredCharts = this.filteredCharts(resolve('charts', sources), resolve('chart.id', sources));

    for (var key in this.parameters) {

      if (this.parameters.hasOwnProperty(key)) {

        let parameter = this.parameters[key];
        if (typeof parameter.source != 'undefined') {
          let items = resolve(parameter.source, sources);
          parameter.items = items != null ? items : [];
          if(parameter.items.length) {
            //  parameter.item = pickItem(parameter);
            //  console.log("parameter.item", parameter.item);
          }

          // console.log("item here", parameter.item);
          parameter.wait = false;
          // parameter.wait = parameter.items.length ? false : true;
        }
      }
    }
  }
  loadDataSources() {
    // @togo
  }
  getApiInput(resetId) {
    this.setSchemaParameters();
    let result = {
      projectId: this.projectId,
      name: this.name,
      type: this.type,
      typeGroup: this.typeGroup,
      description: this.description,
      schema: encode(this.schema),
      content: encode(this.content)
    }
    if (typeof this.id != "undefined") {
      result.id = this.id;
    }
    if(typeof resetId != "undefined" && resetId == true) {
      console.log("recreating chart layer id");
      result.id = guid.createId('chart');
    }
    return result;
  }
  initialiseGrids(tree) {

  }

}
